export enum ICON_SIZES {
  s9 = 0.563,
  s12 = 0.75,
  s14 = 0.875,
  s16 = 1,
  s18 = 1.125,
  s20 = 1.25,
  s22 = 1.375,
  s23 = 1.4375,
  s24 = 1.5,
  s28 = 1.75,
  s30 = 1.875,
  s42 = 2.625,
  s50 = 3.125,
  s75 = 4.688,
}

export type IconProps = {
  size: ICON_SIZES;
  color: string;
  path: React.ReactNode;
  opacity?: number;
};

export const Icon = ({ size, color, path, opacity = 1 }: IconProps) => (
  <svg
    viewBox="0 0 512 512"
    fill={color}
    color={color}
    height={`${size}rem`}
    width={`${size}rem`}
    opacity={opacity}
  >
    {path}
  </svg>
);
